import { Image } from '@/components/atoms/Image/Image';
import { CustomLink } from '../CustomLink/CustomLink';
import { generateClampFromMinMax } from '@/utils/styling';
import { usePageStore } from '@/store/usePageStore';

interface ILogo {
  hasLink?: boolean;
  slug?: string;
}

export const Logo: React.FC<ILogo> = ({ hasLink = true, 
  // slug = '/' 
}) => {
  const locale = usePageStore((s) => s.locale);

  return (
    <>
      {hasLink ? (
        <CustomLink 
          href={locale === 'en' ? '/' : `/${locale}`}
          className="logo-container-link"
        >
          <Image
            src={'/logo.svg'}
            alt={'Berga González'}
            fill={false}
            width={262}
            height={37}
            styles={{
              height: 'min-content',
              width: generateClampFromMinMax(153, 262),
            }}
            priority={true}
          />
        </CustomLink>
      ) : (
        <Image
          src={'/logo.svg'}
          alt={'Berga González'}
          fill={false}
          width={262}
          height={37}
          styles={{
            height: 'min-content',
            width: generateClampFromMinMax(153, 262),
          }}
          priority={true}
        />
      )}
    </>
  );
};
